import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import type { ActionMedia } from '../data/gallery';
interface MediaLightboxProps {
  item: ActionMedia | null;
  lang: 'en' | 'es';
  closeLabel: string;
  onClose: () => void;
}
export function MediaLightbox({
  item,
  lang,
  closeLabel,
  onClose
}: MediaLightboxProps) {
  const closeRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!item) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    closeRef.current?.focus();
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [item, onClose]);
  return <AnimatePresence data-id="element-245" data-mp="2k4pikgyg5d28">
      {item && <motion.div className="fixed inset-0 z-[60] flex items-center justify-center bg-navy/90 p-4" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: [0.23, 1, 0.32, 1]
    }} onClick={onClose} role="dialog" aria-modal="true" aria-label={item.title[lang]} data-id="element-246" data-mp="2p1pu37e2f80q">
          <motion.figure initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0,
        scale: 0.96
      }} transition={{
        duration: 0.22,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-4xl" onClick={event => event.stopPropagation()} data-id="element-247" data-mp="5scizw2g33ib">
            <button ref={closeRef} type="button" onClick={onClose} aria-label={closeLabel} className="absolute -top-12 right-0 flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white transition-colors duration-150 hover:bg-white/20" data-id="element-248" data-mp="tiyrfogd2psu">
              <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-249" data-mp="3ap5sqqcxzj7v" />
            </button>
            <div className="overflow-hidden rounded-xl bg-black" data-id="element-250" data-mp="3foa0dck7x8w3">
              {item.type === 'video' ? <video src={item.src} poster={item.poster} controls autoPlay playsInline className="max-h-[78vh] w-full" data-id="element-251" data-mp="31padoag9n42k" /> : <img src={item.src} alt={item.description[lang]} className="mx-auto max-h-[78vh] w-auto object-contain" data-id="element-252" data-mp="2rx4kwyi6wimb" />}
            </div>
            <figcaption className="mt-4" data-id="element-253" data-mp="2mzl6nylhs5ud">
              <span className="block font-display text-lg font-bold text-white" data-id="element-254" data-mp="2n0e6efm19v30">
                {item.title[lang]}
              </span>
              <span className="mt-1 block text-sm text-white/70" data-id="element-255" data-mp="2dz6lr0cfwsre">{item.description[lang]}</span>
            </figcaption>
          </motion.figure>
        </motion.div>}
    </AnimatePresence>;
}